export * from './cookie-service/cookie.service';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/micro/Downloads/Proyectos/PagosContabilidadUriel/~/ngx-cookie-service/index.js
// module id = ../../../../ngx-cookie-service/index.js
// module chunks = 3